import { clsx } from 'clsx';

interface StatusDotProps {
  status: 'healthy' | 'warning' | 'error' | 'inactive';
  size?: 'sm' | 'md';
  pulse?: boolean;
}

export function StatusDot({ status, size = 'sm', pulse = true }: StatusDotProps) {
  return (
    <span className="relative inline-flex">
      <span
        className={clsx('inline-block rounded-full', {
          'h-2 w-2': size === 'sm',
          'h-3 w-3': size === 'md',
          'bg-emerald-400': status === 'healthy',
          'bg-amber-400': status === 'warning',
          'bg-red-400': status === 'error',
          'bg-surface-500': status === 'inactive',
        })}
      />
      {pulse && status === 'healthy' && (
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-30 animate-ping" />
      )}
    </span>
  );
}
